import client from "./client";

client();
